import { render, staticRenderFns } from "./DeliveryAddressNewPage.vue?vue&type=template&id=850a0d4e&"
import script from "./DeliveryAddressNewPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressNewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports